/* eslint-disable */

export const protobufPackage = "od_protos.web.data";

export interface TitleContact {
  fullName: string;
  email: string;
}

export interface TitleOrganization {
  legalName: string;
  name: string;
  escrowName: string;
}

function createBaseTitleContact(): TitleContact {
  return { fullName: "", email: "" };
}

export const TitleContact = {
  fromJSON(object: any): TitleContact {
    return {
      fullName: isSet(object.fullName) ? String(object.fullName) : "",
      email: isSet(object.email) ? String(object.email) : "",
    };
  },

  toJSON(message: TitleContact): unknown {
    const obj: any = {};
    if (message.fullName !== "") {
      obj.fullName = message.fullName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TitleContact>, I>>(base?: I): TitleContact {
    return TitleContact.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TitleContact>, I>>(object: I): TitleContact {
    const message = createBaseTitleContact();
    message.fullName = object.fullName ?? "";
    message.email = object.email ?? "";
    return message;
  },
};

function createBaseTitleOrganization(): TitleOrganization {
  return { legalName: "", name: "", escrowName: "" };
}

export const TitleOrganization = {
  fromJSON(object: any): TitleOrganization {
    return {
      legalName: isSet(object.legalName) ? String(object.legalName) : "",
      name: isSet(object.name) ? String(object.name) : "",
      escrowName: isSet(object.escrowName) ? String(object.escrowName) : "",
    };
  },

  toJSON(message: TitleOrganization): unknown {
    const obj: any = {};
    if (message.legalName !== "") {
      obj.legalName = message.legalName;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.escrowName !== "") {
      obj.escrowName = message.escrowName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TitleOrganization>, I>>(base?: I): TitleOrganization {
    return TitleOrganization.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TitleOrganization>, I>>(object: I): TitleOrganization {
    const message = createBaseTitleOrganization();
    message.legalName = object.legalName ?? "";
    message.name = object.name ?? "";
    message.escrowName = object.escrowName ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
